<template>
  <div id="health-add" class="sav-wrapper">
    <Topbar/>
		<div class="sav-container">
      <Header back="/new" title="Νέα ασφάλεια υγείας" category="health"/>
      <Add category="health" :id="id" :cardHeaders="healthHeaders" />
    </div>
  </div>
</template>

<script>
import Topbar from './../Topbar.vue'
import Header from './../Header.vue'
import Add from './../Add.vue'
import healthHeaders from './../../../public/data/db.health-single-headers.json'

export default {
	props: ['id'],
    components: {
    Topbar,
    Header,
    Add
  },
  data() {
        return {
            healthHeaders: healthHeaders
        }
	}
}
</script>

<style lang="scss" scoped>
</style>
